import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/layout/Sidebar";
import Navbar from "../components/layout/Navbar";

const DashboardLayout = () => {
    return (
        <div className="flex h-screen overflow-hidden bg-[#F7F5EF] text-[#263746] font-sans">
            {/* Sidebar */}
            <Sidebar />

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col min-w-0">
                <Navbar />

                <main className="flex-1 overflow-y-auto p-4 md:p-8 bg-[#F7F5EF]">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
